import CustomerTourBooking from "../components/customer-tour-booking/customerTourBooking.jsx";

const CustomerTourBookingPage = () => {
  return (
    <div>
      <CustomerTourBooking />
    </div>
  );
};
export default CustomerTourBookingPage;
